import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { useWebWoodContext } from 'context/WebWoodContext'
import { EVENT_TYPES, useSubscribeToEvent } from 'services/event-bus'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { editorSelectors } from 'store/features/editor/selectors'
import { useTimelineContext } from 'context/TimelineContext'
import { projectSelectors } from 'store/features/project/selectors'
import { useLoadingMediasState } from './hooks/use-loading-medias-state'

export const useCanvasUpdates = () => {
  const {
    engine,
    updateCanvasObjects,
    updateCanvasAudios,
    updateCanvasDimensions,
    updateCanvasPlaybackTime,
    play,
    pause
  } = useWebWoodContext()

  const projectId = useSelector(projectSelectors.id)
  const mediaItems = useSelector(projectDataSelectors.mediaItems)
  const multilineAudios = useSelector(projectDataSelectors.multilineAudios)
  const { width: projectWidth, height: projectHeight } = useSelector(
    projectDataSelectors.defaultDimensions
  )
  const { isPlaying, getCurrentTimeImmediate } = useTimelineContext()
  const isAnyBuffering = useSelector(editorSelectors.isAnyBuffering)
  const isCanvasPlaying = isPlaying && !isAnyBuffering

  // if project dimensions change, update canvas dimensions
  useEffect(() => {
    updateCanvasDimensions(projectWidth, projectHeight)
  }, [updateCanvasDimensions, projectWidth, projectHeight])

  // initially create canvas objects
  useEffect(() => {
    if (!engine || !projectId) return
    engine.setProjectId(`${projectId}`)
    engine.setProjectDirectory(`${projectId}`)
    updateCanvasObjects(mediaItems)
    updateCanvasAudios(multilineAudios)
  }, [
    engine,
    projectId,
    mediaItems,
    multilineAudios,
    updateCanvasAudios,
    updateCanvasObjects
  ])

  useLoadingMediasState()

  // handle play/pause
  useEffect(() => {
    if (isCanvasPlaying) {
      play(getCurrentTimeImmediate())
    } else {
      pause()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCanvasPlaying])

  useSubscribeToEvent(
    EVENT_TYPES.PLAYBACK_TIME_CHANGE,
    updateCanvasPlaybackTime
  )
}
